<template>
  <path
    fill="currentColor"
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M14 3V3.28988C16.8915 4.15043 19 6.82898 19 10V17H20V19H4V17H5V10C5 6.82898 7.10851 4.15043 10 3.28988V3C10 1.89543 10.8954 1 12 1C13.1046 1 14 1.89543 14 3ZM17 17V10C17 7.23858 14.7614 5 12 5C9.23858 5 7 7.23858 7 10V17H17ZM14 21V20H10V21C10 22.1046 10.8954 23 12 23C13.1046 23 14 22.1046 14 21ZM6 1.28979C3.10851 2.15034 1 4.8289 1 7.99992V8.99992H3V7.99992C3 5.9496 4.2341 4.18752 6 3.41596V1.28979ZM23 7.99992C23 4.8289 20.8915 2.15034 18 1.28979V3.41596C19.7659 4.18752 21 5.9496 21 7.99992V8.99992H23V7.99992Z"
  />
</template>
